import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import ScanScreen from './components/ScanScreen';
import Register from './components/Register';

function App() {
  // Vérifie si l'utilisateur est connecté en regardant le localStorage
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('driverUser'));

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('driverUser');
    setIsLoggedIn(false);
  };

  return (
    <Router>
        <div className="App">
            <Routes>
                <Route 
                  path="/login" 
                  element={!isLoggedIn ? <Login onLogin={handleLogin} /> : <Navigate to="/" />} 
                />
                <Route path="/register" element={<Register />} />
                <Route 
                  path="/" 
                  element={isLoggedIn ? <ScanScreen onLogout={handleLogout} /> : <Navigate to="/login" />} 
                />
            </Routes>
        </div>
    </Router>
  );
}

export default App;
